const contentBuilderStyles = {
    header: {
      textAlign: "center",
      fontSize: "26px",
      marginBottom: "20px",
    },
    selectContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "15px",
    },
    label: {
      fontSize: "16px",
      fontWeight: "bold",
    },
    select: {
      padding: "8px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    },
    bannerRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
      marginBottom: "15px",
    },
    button: {
      padding: "10px",
      backgroundColor: "#007BFF",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    previewContainer: {
      marginTop: "20px",
      marginBottom: "20px",
    },
    iframeWrapper: {
      position: "relative",
      overflow: "auto",
    },
    iframe: {
      width: "100%",
      height: "calc(100vh - 200px)",
      border: "1px solid #ccc",
      overflow: "auto",
    },
    subHeading: {
      marginBottom: "10px",
      fontSize: "18px",
    },
    instructionBanner: {
      padding: "10px",
      backgroundColor: "#e0f7fa",
      border: "1px solid #b2ebf2",
      borderRadius: "5px",
      marginBottom: "15px",
      textAlign: "center",
      fontSize: "14px",
    },
  };
  
  export default contentBuilderStyles;
